module.exports = __webpack_public_path__ + "static/media/redArrow.83e0af10.svg";